import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Package } from '../shared/interface/package';
import { PackageService } from '../shared/services/package/package.service';
import { UserService } from '../shared/services/user/user.service';

@Component({
  selector: 'app-subscribe-package',
  templateUrl: './subscribe-package.component.html',
  styleUrls: ['./subscribe-package.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscribePackageComponent implements OnInit {
  packages: Package[];
  currentSubscription: string = "";
  isAuthenticated: boolean = false;

  constructor(private packageService: PackageService, private userService: UserService) {
    this.isAuthenticated = this.userService.isAuthenticated();
  }

  ngOnInit() {
    //this.currentSubscription = this.getCurrentPackage.package.packageId;
    this.currentSubscription = "0";
    if(this.isAuthenticated){
      this.currentSubscription = this.userService.getLoggedInUser().package.packageId;
    }
    this.setList();
    // this.packages = [
    //   { _id: "1", packageName: "Beginner", price: 39, tenure: "per month", deviceCount: 1 },
    //   { _id: "2", packageName: "Standard", price: 59, tenure: "per month", deviceCount: 3 },
    //   { _id: "3", packageName: "Premium", price: 75, tenure: "per month", deviceCount: 5 },
    // ];
  }

  setList() {
    this.packageService.list("sort=deviceCount-asc").subscribe(res => {
      this.packages = res;
    }, (err) => { });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/subscribe-package/subscribe-package.component.ts